const feeOnTransferCheckAbi = [
  { inputs: [], name: "PairLookupFailed", type: "error" },
  { inputs: [], name: "SameToken", type: "error" },
  {
    inputs: [{ internalType: "string", name: "reason", type: "string" }],
    name: "UnknownExternalTransferFailure",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "factoryV2", type: "address" },
      { internalType: "address[]", name: "tokens", type: "address[]" },
      { internalType: "address", name: "baseToken", type: "address" },
      { internalType: "uint256", name: "amountToBorrow", type: "uint256" },
    ],
    name: "batchValidate",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "buyFeeBps", type: "uint256" },
          { internalType: "uint256", name: "sellFeeBps", type: "uint256" },
          { internalType: "bool", name: "feeTakenOnTransfer", type: "bool" },
          {
            internalType: "bool",
            name: "externalTransferFailed",
            type: "bool",
          },
          { internalType: "bool", name: "sellReverted", type: "bool" },
        ],
        internalType: "struct TokenFees[]",
        name: "fotResults",
        type: "tuple[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "contract ERC20", name: "token", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "callTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "contract ERC20", name: "token", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "uint256", name: "expectedBalance", type: "uint256" },
    ],
    name: "callTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "uint256", name: "amount0", type: "uint256" },
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "bytes", name: "data", type: "bytes" },
    ],
    name: "uniswapV2Call",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "factoryV2", type: "address" },
      { internalType: "address", name: "token", type: "address" },
      { internalType: "address", name: "baseToken", type: "address" },
      { internalType: "uint256", name: "amountToBorrow", type: "uint256" },
    ],
    name: "validate",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "buyFeeBps", type: "uint256" },
          { internalType: "uint256", name: "sellFeeBps", type: "uint256" },
          { internalType: "bool", name: "feeTakenOnTransfer", type: "bool" },
          {
            internalType: "bool",
            name: "externalTransferFailed",
            type: "bool",
          },
          { internalType: "bool", name: "sellReverted", type: "bool" },
        ],
        internalType: "struct TokenFees",
        name: "fotResult",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export default feeOnTransferCheckAbi;
